import devRoutes from "./Routes";

export const routes = devRoutes;